import { NgModule } from '@angular/core';
import { AddTableStyleClassDirective } from './add-table-styleclass.directive';

@NgModule({
  declarations: [AddTableStyleClassDirective],
  exports: [AddTableStyleClassDirective],
})
export class AddTableStyleClassModule {}
